import { Container, Grid } from '@mui/material';
import React from 'react';
import UserProjectSection from '../../components/MyProfile/user-projects/UserProjectSection';
import NewLayout from '../../layout/dashboard/NewLayout';
import AssignedProjects from '../../components/MyProfile/user-projects/AssignedProjects';
import { useRole } from '../../hooks/useRole';
import Loader from '../../components/elements/Loader';

const UserProjectsPage = () => {
  const role = useRole();
  if (!role) {
    return <Loader />;
  }
  return (
    <NewLayout>
      <Container maxWidth="xxl">
        <Grid container spacing={2}>
          <Grid item md={12}>
            {(role === 'org-admin' || role === 'org-manager') ? (
              <UserProjectSection />
            ) : (
              <AssignedProjects />
            )}
          </Grid>
        </Grid>
      </Container>
    </NewLayout>
  );
};

export default UserProjectsPage;
